export const CACHE_TIME = 3600000;
export const STALE_TIME = 3600000;

export const modelSetCacheKey = ['model-sets'];
